import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";
import { ADMIN } from "@/constants/testIds";
import { Fish, LogIn } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (ex) {
      setErr(formatApiError(ex));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#F0F8FF]">
      <div className="hidden lg:block relative">
        <img src="/assets/silaing/hero.png" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-br from-[#003A5C]/95 via-[#005F8E]/85 to-[#00B4D8]/60" />
        <div className="relative h-full flex flex-col justify-between p-12 text-white">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-xl bg-white/95 grid place-items-center p-1.5">
              <img src="/assets/silaing/logo-jabar.png" alt="Logo Pemprov Jabar" className="w-full h-full object-contain" />
            </div>
            <div>
              <div className="font-heading font-bold text-xl leading-none">SILAING</div>
              <div className="text-[10px] uppercase tracking-widest text-[#48CAE4] mt-1">DKP Jawa Barat</div>
            </div>
          </Link>
          <div>
            <h2 className="font-heading font-bold text-4xl leading-tight mb-3">Panel Admin</h2>
            <p className="text-white/80 max-w-md">Kelola konten portal SILAING — berita, regulasi, galeri, agenda, dan pesan kontak dalam satu tempat.</p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md bg-white rounded-3xl shadow-xl p-8 border border-slate-100">
          <div className="mb-8">
            <div className="text-xs uppercase tracking-widest text-[#0086C6] font-semibold mb-2">Masuk</div>
            <h1 className="font-heading font-bold text-3xl text-[#003A5C]">Selamat Datang</h1>
            <p className="text-slate-600 text-sm mt-2">Silakan login untuk mengelola portal SILAING.</p>
          </div>

          {err && <div className="mb-4 p-3 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm">{err}</div>}

          <label className="block text-xs uppercase tracking-widest text-slate-600 font-semibold mb-1.5">Email</label>
          <input required type="email" data-testid={ADMIN.loginEmail} value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full rounded-lg border border-slate-200 px-4 py-3 focus:border-[#00B4D8] outline-none mb-4" placeholder="admin@dkp.jabar.go.id" />

          <label className="block text-xs uppercase tracking-widest text-slate-600 font-semibold mb-1.5">Password</label>
          <input required type="password" data-testid={ADMIN.loginPassword} value={password} onChange={(e) => setPassword(e.target.value)}
            className="w-full rounded-lg border border-slate-200 px-4 py-3 focus:border-[#00B4D8] outline-none mb-6" placeholder="••••••••" />

          <button type="submit" disabled={busy} data-testid={ADMIN.loginSubmit}
            className="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-[#005F8E] hover:bg-[#003A5C] text-white font-bold disabled:opacity-60 transition-colors">
            <LogIn className="w-4 h-4" /> {busy ? "Memproses..." : "Masuk"}
          </button>

          <Link to="/" className="block text-center text-sm text-slate-500 hover:text-[#005F8E] mt-6">← Kembali ke portal publik</Link>
        </form>
      </div>
    </div>
  );
}
